<template>
  <div class="editor">
    <editor-menu-bar :editor="editor">
      <div
        class="menubar is-hidden"
        :class="{ 'is-focused': focused }"
        slot-scope="{ commands, isActive, focused }"
      >

        <bold-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <italic-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <underline-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <strikethrough-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <paragraph-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <h1-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <!--
        <h2-button v-bind:commands="commands" v-bind:isActive="isActive" />
        -->
        <h3-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <bullet-list-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <number-list-button v-bind:commands="commands" v-bind:isActive="isActive" />
        <block-quote-button v-bind:commands="commands" v-bind:isActive="isActive" />
<!--
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <icon name="italic" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          <icon name="strike" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <icon name="underline" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.code() }"
          @click="commands.code"
        >
          <icon name="code" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.paragraph() }"
          @click="commands.paragraph"
        >
          <icon name="paragraph" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >
          H1
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          H2
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          H3
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <icon name="ul" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <icon name="ol" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.blockquote() }"
          @click="commands.blockquote"
        >
          <icon name="quote" />
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.code_block() }"
          @click="commands.code_block"
        >
          <icon name="code" />
        </button>
-->
      </div>
    </editor-menu-bar>

    <editor-content class="editor__content" :editor="editor" v-model="content" />
  </div>
</template>

<script>
  import RichText from './RichText.ts';

  export default RichText
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/variables.scss";
  @import "@/assets/scss/main.scss";
</style>